import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import RowActionsMenu from "../UI/RowActionsMenu";
import EmptyState from "../UI/EmptyState";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditPlayerDialog from "./EditPlayerDialog";
import DeletePlayerDialog from "./DeletePlayerDialog";

const PlayersTable = (props) => {
  const navigate = useNavigate();
  const [editRow, setEditRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);

  const rows = props.players.map(({ id, name, originId, user, team }) => ({
    id,
    name,
    originId,
    user,
    team,
  }));

  const playersWithPermission = props.playersWithPermission.map((p) => p.id);

  if (rows.length === 0) {
    console.log("PlayersTable empty", { rows });
    return <EmptyState icon={<PersonOutlineIcon />} message="No players found." />;
  }

  console.log("PlayersTable rows", { rows });

  return (
    <>
      <TableContainer
        className="tableContainer"
        data-testid="playersTable"
        component={Paper}
        sx={{ overflowX: "auto" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {playersWithPermission.length > 0 && <TableCell sx={{ width: 48, p: 0.5 }} />}
              <TableCell>Name</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Team</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                data-testid={"playerTableRow" + row.id}
                hover
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: "pointer" }}
                onClick={() => navigate(`/player/${row.id}`)}
              >
                {playersWithPermission.length > 0 && (
                  <TableCell sx={{ width: 48, p: 0.5 }} onClick={(e) => e.stopPropagation()}>
                    {playersWithPermission.includes(row.id) && (
                      <RowActionsMenu
                        onEdit={() => setEditRow(row)}
                        onDelete={() => setDeleteRow(row)}
                      />
                    )}
                  </TableCell>
                )}
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.user.username}</TableCell>
                <TableCell>{row.team.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {editRow && (
        <EditPlayerDialog
          open
          setOpen={(open) => !open && setEditRow(null)}
          player={editRow}
        />
      )}
      {deleteRow && (
        <DeletePlayerDialog
          open
          setOpen={(open) => !open && setDeleteRow(null)}
          player={deleteRow}
        />
      )}
    </>
  );
};

export default PlayersTable;
